import React, { useState } from 'react';
import Accordion from '../../components/common/Accordion';

const InvoiceUploadErrors = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const errors = [
    {
      category: "ヘッダー不足によるエラー (CF101)",
      description: "CSVファイルの1行目（ヘッダー）に必要な列名がない場合に表示されます。",
      items: [
        { title: "エラー：「必須のヘッダーが不足しています: stripe_customer_id」", content: "CSVファイルのヘッダーに stripe_customer_id の列名が存在しません。必須項目のため、ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: paymentsettings」", content: "CSVファイルのヘッダーに paymentsettings の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: price_id」", content: "CSVファイルのヘッダーに price_id の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: quantity」", content: "CSVファイルのヘッダーに quantity の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: description」", content: "CSVファイルのヘッダーに description の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: unit_amount」", content: "CSVファイルのヘッダーに unit_amount の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: tax」", content: "CSVファイルのヘッダーに tax の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: period_start」", content: "CSVファイルのヘッダーに period_start の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: period_end」", content: "CSVファイルのヘッダーに period_end の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: due_date」", content: "CSVファイルのヘッダーに due_date の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: issue_at」", content: "CSVファイルのヘッダーに issue_at の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
        { title: "エラー：「必須のヘッダーが不足しています: draft」", content: "CSVファイルのヘッダーに draft の列名が存在しません。ヘッダーに列を追加してください。", code: "CF101" },
      ]
    },
    {
      category: "データ内容によるエラー",
      description: "ヘッダーは正しくても、各行のデータの内容に問題がある場合に表示されます。",
      items: [
        {
          title: "エラー：「stripe_customer_id は必須です」 (エラーコード: CV201)",
          code: "CV201",
          content: "原因：必須項目である stripe_customer_id 列に値が入力されていません。 解決策：対象の行に、Stripe上で登録されている正しい顧客IDを入力してください。"
        },
        {
          title: "エラー：「price_id または unit_amount のいずれか一方を設定してください」 (エラーコード: CV202)",
          code: "CV202",
          content: "原因：価格情報が設定されていません。price_id と unit_amount の両方の列が空欄になっています。 解決策：price_id（Stripeに登録済みの価格ID）か、unit_amount（単価）のどちらか一方の列に値を入力してください。"
        },
        {
          title: "エラー：「quantity は必須です」 (エラーコード: CV203)",
          code: "CV203",
          content: "原因：quantityが空欄です。 解決策：quantity 列に、1以上の半角整数の値を入力してください。"
        },
        {
          title: "エラー：「quantity は1以上の整数である必要があります」 (エラーコード: CV204)",
          code: "CV204",
          content: "原因：quantityが0、マイナス、または少数点を含む数値になっています。 解決策：quantity 列に、1以上の半角整数の値を入力してください。"
        },
        {
          title: "エラー：「unit_amount は0以上の数値である必要があります」 (エラーコード: CV205)",
          code: "CV205",
          content: "原因：unit_amount（単価）列に、数字以外の文字（通貨記号、カンマ、全角文字など）が含まれています。 解決策：unit_amount 列には、半角数字のみを入力してください。（例: 5000）"
        },
        {
          title: "エラー：「tax は0以上の整数である必要があります」 (エラーコード: CV206)",
          code: "CV206",
          content: "原因：tax 列にマイナスの数値が入力されている、またはStripeに登録されていない税率IDが入力されています。 解決策：税率を指定する場合は、Stripeのダッシュボードで設定した税率ID（txr_...）を正しく入力してください。税率が不要な場合は、この列を空欄にしてください。"
        },
        {
          title: "エラー：「period_start の日付が不正です」 (エラーコード: CV207)",
          code: "CV207",
          content: "原因：period_start 列が空欄、または YYYY/MM/DD、YYYY-MM-DD 以外の形式で入力されています。 解決策：period_start 列に、サービス提供期間の開始日を YYYY/MM/DD（もしくはYYYY-MM-DD） の形式（例: 2024/08/25）で入力してください。"
        },
        {
          title: "エラー：「period_end の日付が不正です」 (エラーコード: CV208)",
          code: "CV208",
          content: "原因：period_end 列が空欄、または YYYY/MM/DD、YYYY-MM-DD 以外の形式で入力されています。 解決策：period_end 列に、サービス提供期間の終了日を YYYY/MM/DD（もしくはYYYY-MM-DD） の形式（例: 2024/09/24）で入力してください。"
        },
        {
          title: "エラー：「period_end は period_start 以降の日付である必要があります」 (エラーコード: CV209)",
          code: "CV209",
          content: "原因：period_end の日付が、period_start よりも前の日付に設定されています。 解決策：サービス提供期間の終了日は、開始日と同じか、それ以降の日付に設定してください。"
        },
        {
          title: "エラー：「paymentsettings は必須です」 (エラーコード: CV210)",
          code: "CV210",
          content: "原因：payment_settings 列に支払い方法が指定されていません。 解決策：payment_settings 列に、card（カード払い）または bank_transfer（銀行振込）のいずれかを入力してください。"
        },
        {
          title: "エラー：「due_date の日付が不正です」 (エラーコード: CV211)",
          code: "CV211",
          content: "原因：due_date 列の日付が YYYY/MM/DDもしくはYYYY-MM-DD 以外の形式で入力されています。 解決策：due_date 列に、支払期日を YYYY/MM/DD（もしくはYYYY-MM-DD） の形式（例: 2024/09/30）で入力してください。"
        },
        {
          title: "エラー：「paymentsettings が bank の場合、due_date は必須です」 (エラーコード: CV212)",
          code: "CV212",
          content: "原因：支払い方法が銀行振込にもかかわらず、due_date 列が空欄になっています。 解決策：支払い方法に bank_transfer を指定した場合は、due_date 列に支払期日を YYYY/MM/DDもしくはYYYY-MM-DD の形式（例: 2024/09/30）で必ず入力してください。"
        },
        {
          title: "エラー：「paymentsettingsには'card'または'bank'のみ指定できます」 (エラーコード: CV216)",
          code: "CV216",
          content: "原因：paymentsettings にcard, bank以外の文字列が入力されています。 解決策：paymentsettingsにはcard, bankのいずれかを入力してください。"
        },
        {
          title: "エラー：「issue_atは30日以内の未来の日時のみ指定できます。」 (エラーコード: CV217)",
          code: "CV217",
          content: "原因：issue_at 日付のフォーマットが無効、または有効な日時ではありません。 解決策：issue_at に30日以内の未来の日時（例: 2024/10/31 10:00）を指定してください。"
        },
        {
          title: "エラー：「draftの値は空欄か1のみ有効です」 (エラーコード: CV218)",
          code: "CV218",
          content: "原因：draft 列に空欄または 1 以外の値が入力されています。 解決策：下書きとして作成する場合は 1 を入力し、即時発行する場合は空欄にしてください。"
        },
        {
          title: "エラー：「現在のプランの上限を超えるため、処理を中断しました」 (エラーコード: SF301)",
          code: "SF301",
          content: "原因：アップロードする請求書の件数が、現在のプランの上限を超えてしまいます。 解決策：一度にアップロードする件数を減らすか、プランのアップグレードをご検討ください。"
        },
        {
          title: "エラー：「税率設定が見つかりません。 tax 列の値を確認してください」 (エラーコード: SF302)",
          code: "SF302",
          content: "原因：CSVのtax列に入力された番号が、BillWaveの「税率設定」画面で登録されていないため、どのStripe税率IDを適用すればよいか不明な状態です。 解決策：BillWaveの「税率設定」画面を開き、使用したい税率が登録されているか確認してください。登録されていない場合は、新しい税率設定を追加してください。登録されている場合は、CSVのtax列の番号が正しいか確認してください。"
        },
      ]
    },
    {
      category: "Stripe APIからのエラー",
      description: "CSVの内容が正しくても、Stripe側での処理中に発生するエラーです。",
      items: [
        {
          title: "エラー：「customer_idが存在しません」 (エラーコード: SA401)",
          code: "SA401",
          content: "原因：CSVに指定された stripe_customer_id が、Stripe上に存在しないか、間違っています。 解決策：Stripeのダッシュボードで正しい顧客IDを確認し、CSVファイルを修正してください。"
        },
        {
          title: "エラー：「price_idが存在しません」 (エラーコード: SA402)",
          code: "SA402",
          content: "原因：CSVに指定された price_id が、Stripe上に存在しないか、間違っています。 解決策：Stripeのダッシュボードで正しい価格IDを確認するか、price_id を空にして unit_amount を使用してください。"
        },
        {
          title: "エラー：「税金の計算方法がStripe上の設定と競合しています」 (エラーコード: SA403)",
          code: "SA403",
          content: "原因：CSVで指定したprice_id（価格）に設定されているStripe上のtax_behavior（税金の取り扱い：内税/外税）と、請求書に適用しようとしている税率が競合しています。例えば、内税価格に外税の税率を適用しようとした場合などに発生します。 解決策：Stripeダッシュボードで、該当するprice_idの「税金の取り扱い」設定を確認してください。必要に応じて価格設定を修正するか、CSVのtax列の指定を見直してください。"
        },
        {
          title: "エラー：「支払期日(due_date)が過去の日付です」 (エラーコード: SA404)",
          code: "SA404",
          content: "原因：銀行振込（bank）で指定されたdue_date（支払期日）が、請求書を処理する時点ですでに過去の日付になっています。 解決策：CSVファイルのdue_date列の値を確認し、未来の日付に修正してください。"
        }
      ]
    }
  ];

  const filteredErrors = errors.map(category => ({
    ...category,
    items: category.items.filter(item => 
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
      item.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.content.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        請求書CSVアップロードのエラー
      </h1>
      <p className="text-gray-600 mb-6">
        CSVアップロードボタンを押した後に表示されるエラーの一覧です。エラーメッセージに記載された内容や行番号を元に、元のCSVファイルを修正してください。
      </p>

      {/* Search Box */}
      <div className="mb-8">
        <input
          type="text"
          placeholder="エラーコードやキーワードで検索..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredErrors.length > 0 ? (
        filteredErrors.map((category, catIndex) => (
          <div key={catIndex} className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4 border-b pb-2">{category.category}</h2>
            <p className="text-gray-600 mb-6">{category.description}</p>
            {category.items.map((item, itemIndex) => (
              <Accordion key={itemIndex} title={item.title}>
                <div className="p-4">
                  {/* content is already a string with 原因/解決策 for some, or just description for others */}
                  {item.content.includes('原因：') ? (
                    <div className="space-y-4">
                      {item.content.split(' 解決策：').map((part, i) => (
                        <div key={i}>
                          <h4 className="font-semibold text-gray-700">{i === 0 ? '原因：' : '解決策：'}</h4>
                          <p className="text-gray-700 mt-1">{part.replace('原因：', '')}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>{item.content}</p>
                  )}
                </div>
              </Accordion>
            ))}
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500 my-8">一致するエラーが見つかりませんでした。</p>
      )}
    </div>
  );
};

export default InvoiceUploadErrors;
